/*eslint-disable */
import {
  bus
} from '../../main';
import {
  mapGetters
} from 'vuex';
const $ = window.jQuery = require('jquery');
import toast from '../../services/toast';
import excel from '../../assets/images/excel.png';
import docx from '../../assets/images/docx.png';
import pdf from '../../assets/images/pdf.png';
import ppt from '../../assets/images/ppt.png';
import moment from 'moment';
import videoSocketRef from "../../videoNotificationSocket";
export default {
  name: 'chat-normal-user-list',
  components: {},
  props: [],
  data() {
    return {
      selectedUser: '',
      submitted: false,
      userChatContent: [],
      chatSocket: '',
      userId: '',
      roomChatId: '',
      checkSocketId: '',
      socketCheck: '',
      getUserDetailsID: '',
      listLoading: true,
      roomChatTabContent: true,
      normalChatListData: [],
      chatId: '',
      checkDataTaskModal:false,
      blockedUserId:'',
      blockedUserEmail:'',
      chatUserListes:[],
      uploadFile:null,
      filename:'',
      imgSrc:'',
      fileMessage:'',
      roomChatIdForFile:'',
      uploadedFileUrl:'',
      connectionRequestState:'',
      connectionRequestStatus:'',
      videoSocketStart:'',
      search_term:'',
      userSearchListTabs:false,
      userSearchListTabDetails:false,
      charSearchUserList:[],
      selectedChatFromUserDetails:'',
      searchingContactText:'Looking for contact'
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun() {
      this.userId = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
  },
  mounted() {
    bus.$emit('clearMessageNotifications', {});
    bus.$on('userUpdateStatus', (data) => {
      let user = this.normalChatListData.find(item => item.user.id == data.userID);
      if(user) {
        user.user.is_online = data.is_online;
      }
    });
    bus.$on('connectionRequestBus', (data) => {
      this.connectionRequestStatus = data;
      this.connectionRequestState = data
      setInterval(() => {
        if(this.connectionRequestStatus){
          this.connectionRequestState = this.connectionRequestStatus
        }
      }, 10);
    })
    bus.$on('updateMessageNotification', (data) => {
      let currentSelected = JSON.parse(localStorage.getItem('adminNormalchatUserInfo'));
      currentSelected = currentSelected.id;
      if(data.fromUserID == currentSelected) return;

      let user = this.normalChatListData.find(item => item.user.id == data.fromUserID);
      if(user) {
        user.unread_count = data.unreadCount;
      }
    });
    this.getUserDetailsAgainFun
    var _self = this
    $(document).ready(function () {
      setTimeout(() => {
        _self.chatRoomTabActv()
      }, 10)
      $('.chat_menuburger').click(function(){
        $('.chat_menuburger_wrp').toggleClass('active')
      })
      $(document).click(function(event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".chat_menuburger, .chat_menu_list").length) {
        $(".chat_menuburger_wrp").removeClass("active");
        }
      });
      // User Search For New Chat
      $('.user_search_for_new_chat .form-control').on({
        focus: function() {
          $('.user_search_for_new_chat').addClass('search_enabled')
        },
        blur: function() {
          $('.user_search_for_new_chat').removeClass('search_enabled')
        }
      });
    })
    setTimeout(() => {
      this.listLoading = false
    }, 500)
    this.binddateTimeShown();
  },
  methods: {
    // User Search For New Chat Api
    validateSearchUserBeforeSubmit(){
    },
    onChangeSearchUser(e){
      if(this.search_term.length >= 3){
        this.roomChatTabContent = false
        this.userSearchListTabs = true
        $('.user_search_for_new_chat').addClass('searching_enabled')
        $('.x-alt').addClass("search_disabled_btn")
        this.$store.dispatch('userSearchForNewChatFun', { search_term: this.search_term }).then((response) => {
          if(response.status == '201'){
            this.charSearchUserList = response.data.data
          }
        })
      }else{
        this.roomChatTabContent = true
        this.userSearchListTabs = false
        $('.user_search_for_new_chat').removeClass('searching_enabled')
        $('.x-alt').removeClass("search_disabled_btn")
        this.charSearchUserList = []
      }
    },
    // Close User Searchbar
    searchBarForChatClosedFun(){
      this.roomChatTabContent = true
      this.userSearchListTabs = false
      $('.user_search_for_new_chat').removeClass('searching_enabled')
      $('.x-alt').removeClass("search_disabled_btn")
      this.charSearchUserList = []
      this.search_term = ''
    },
    // Video Call Request Function
    videoCallRequestFun(callerId, callerFirstName, callerLastName){
      $('.video_call_request').removeClass('call_actv')
      $('#videocallbtn' + callerId).addClass('call_actv')
      let callerFullName = this.userId.first_name + ' ' + this.userId.last_name
      videoSocketRef.emit({
        message: `${callerFullName} is calling you.`,
        type: "videoCalling",
        displayName: callerFullName,
        callerID: this.userId.id,
        targetId:callerId,
      });
      videoSocketRef.$on('videoCallAcceptedNotification', this.getAnswerOfVideoCall);
      videoSocketRef.$on('videoCallDeclinedNotification', this.getDeclinedOfVideoCall);
      videoSocketRef.$on('videoCallAlertPopupClosed', this.notRecievedCall);
    },
    getAnswerOfVideoCall(getAnswerData){
        this.$router.push('/video/room/one-to-one-peer/#' + getAnswerData.videoCallRoomId)
      // window.location.href = '/video/room/#' + getAnswerData.videoCallRoomId;
    },
    getDeclinedOfVideoCall(declinedData){
      $('#videocallbtn' + declinedData.videoCallDeclinedId).removeClass('call_actv')
    },
    notRecievedCall(notRecievedData){
      $('#videocallbtn' + notRecievedData.notRecivedCallerId).removeClass('call_actv')
    },
    // Chat User Active Function
    chatRoomTabActv() {
      this.checkSocketId = ''
      if(this.socketCheck){
        this.socketCheck.close();
      }
      this.roomChatTabContent = true
      this.listLoading = true
      this.$store.dispatch('normalChatListFun').then((res) => {
        this.normalChatListData = res.data.data
        setTimeout(() => {
          $('.chat_user_listed').removeClass('active');
          $('.chat_user_listed').first().addClass('active');
          if(this.normalChatListData.length > 0){
            document.querySelector('.chat_user_listed.active .chats_tab_name').click()
          }
        }, 100)
        this.listLoading = false
      }).catch((err) => {

      })
    },
    dateTimeShown(id) {
      $('.msg_shown' + id).parent().toggleClass('time_d_shown')
    },
    binddateTimeShown() {
      $(document).on('click','.msg_link_chat', function(e){
        e.preventDefault();
        $(this).parent().parent().toggleClass('time_d_shown');
      });
    },
    socketMsgReadFun(id, senderId){
      this.$store.dispatch('msgReadStatusFun', {message_id :id, user:senderId}).then((res)=>{}).catch((err)=>{})
    },
    getUserDetailsFromChatFun(id, userItemsData, userDetails) {
      this.userChatContent = []
      this.selectedChatFromUserDetails = userDetails
      let userChatListing = '#userChatListingId' + id;
      $('.chat_user_listed').removeClass('active');
      $(userChatListing).addClass('active');
      this.submitted = true
      var ChatId = id
      var selectedChatId = '';
      let user = this.normalChatListData.find(item => item.user.id == ChatId);
      if(user) {
        user.unread_count = 0;
      }
      var messagesList = document.getElementById('reply_msg_list')
      messagesList.innerHTML = "";
      localStorage.removeItem('adminNormalchatUserInfo')
      let data = {
        users: [ChatId, this.userId.id],
        is_support_chat: false
      }
      this.$store.dispatch('chatRoomCreatedFun', data).then((res) => {
        localStorage.setItem('adminNormalchatUserInfo', JSON.stringify(userItemsData))
        var chatId = res.data.data.id
        selectedChatId = res.data.data.id;
        this.roomChatIdForFile = res.data.data.id
        this.getUserDetailsID = res.data.data.to_user
        this.roomChatId = chatId.replace(/-/g, "")
        this.$store.dispatch('getUserChatDetailsByIdFun', { id: chatId }).then((res) => {
          this.userChatContent = res.data.data
          $('.sent_list').remove()
          $('.recieved_list').remove()
          var elmnt = document.getElementById("chatbot_scroll");
          var y = elmnt.scrollHeight;
          setTimeout(() => {
            $('#chatbot_scroll').scrollTop(y)
          }, 100)
          if(this.userChatContent && this.userChatContent.length > 0){
            this.$store.dispatch('msgReadStatusFun', {message_id : this.userChatContent.slice(-1)[0].id, user:ChatId}).then((res)=>{
            }).catch((err)=>{})
          }
        }).catch((err) => {
        })
        if(this.userSearchListTabs ==  true){
          this.normalChatListData = []
          this.$store.dispatch('normalChatListFun').then((res) => {
            this.normalChatListData = res.data.data
            $('.chat_user_listed').removeClass('active');
            let userChatListing = '#userChatListingId' + id;
            setTimeout(() => {
              $(userChatListing).addClass('active');
            }, 100);
            this.searchBarForChatClosedFun()
          })
        }
        // console.log(userItemsData.email, "User EMail", this.roomChatId, "room chat Id", this.checkSocketId, 'Socket Start After')
        if (this.checkSocketId) {
          if (this.roomChatId != this.checkSocketId) {
            this.socketCheck.close();
          }
        }
        if (this.roomChatId != this.checkSocketId) {
          var socketCheck = new WebSocket(
            'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
            '/ws/chat/' + this.roomChatId + '/'
          );
          console.log(userItemsData.email, 'Socket Start Before')
          // console.log(this.roomChatId, 'Check Admin Room ID')
          this.checkSocketId = socketCheck.url.split('/')[5]
          this.socketCheck = socketCheck
          var currentUserEmail = userItemsData.email
          socketCheck.onclose = function (e) {
            console.log('Chat socket closed unexpectedly');
          };
          var _self = this
          socketCheck.onmessage = function (e) {
            var data = JSON.parse(e.data);
            var message = JSON.parse(data.message);
            var li = document.createElement("li");
            var div = document.createElement("div");
            var p = document.createElement("p");
            var a = document.createElement("a");
            var img = document.createElement("img");
            var span = document.createElement("span");
            var time = document.createElement("time");
            let dateTimeAdd = [moment(message.chat_data.current_time).format('MMMM Do YYYY'), ' '+moment(message.chat_data.current_time).format('h:mm a')];
            //_self.socketMsgReadFun(message.chat_data.message_id,message.user)
            time.appendChild(document.createTextNode(dateTimeAdd));
            time.setAttribute("class", "msg_time");
            li.appendChild(div);
            if(message.chat_data.is_file){
              var msgExt = message.message.split(".").slice(-1)[0].substr(0, 3)
              span.appendChild(div);
              div.setAttribute("class", 'msg_in_file');
              div.appendChild(a);
              a.setAttribute("href", message.message);
              a.setAttribute("target", "_new");
              a.appendChild(img);
              if(msgExt = 'xls'){
              img.setAttribute("src", excel);
              }else if(msgExt = 'pdf'){
              img.setAttribute("src", pdf);
              }else if(msgExt = 'ppt'){
                img.setAttribute("src", ppt);
              }else{
                img.setAttribute("src", message.message);
              }
              div.after(document.createTextNode(message.chat_data.message));
              div.after(time);
            }else{
              if(message.chat_data.message.split(':/')[0] == 'http' || message.chat_data.message.split(':/')[0] == 'https'){
                a.setAttribute("href", message.chat_data.message);
                a.setAttribute("target", "_new");
                a.setAttribute("class", 'hyper_link');
                a.appendChild(document.createTextNode(message.chat_data.message));
                p.appendChild(a);
                div.appendChild(p);
                console.log(message.chat_data.message.split(':/')[0], "Msg List")
                div.appendChild(time);
              }else{
                a.setAttribute("href", "javascript:void(0)");
                a.setAttribute("class", 'msg_link_chat');
                a.appendChild(document.createTextNode(message.chat_data.message));
                p.appendChild(a);
                div.appendChild(p);
                div.appendChild(time);
              }
            }
            if (message.chat_data.email == currentUserEmail) {
              div.setAttribute("class", 'recieved');
            } else {
              div.setAttribute("class", 'sent');
            }
            messagesList.appendChild(li);
            var elmnt = document.getElementById("chatbot_scroll");
            var y = elmnt.scrollHeight;
            setTimeout(() => {
              $('#chatbot_scroll').scrollTop(y)
            }, 100)
          };
          document.querySelector('#chat-message-reply-input').focus();
          document.querySelector('#chat-message-reply-input').onkeyup = function (e) {
            if (e.keyCode === 13) {  // enter, return
              document.querySelector('#chat-message-reply-submit').click();
            }
          };
          document.querySelector('#chat-message-reply-submit').onclick = function (e) {
            var messageInputDom = document.querySelector('#chat-message-reply-input');
            var message = messageInputDom.value;
            if (message.length > 0) {
              var sentUserInfo = JSON.parse(localStorage.getItem('adminNormalchatUserInfo'));
              _self.selectedUser = sentUserInfo.id;
              let sentData = {
                'message': message,
                type: 'sent',
                email: sentUserInfo.email,
                name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name
              }
              const currentUserId = localStorage.getItem('LoginedUserID');
              const payload = {
                toUserID: sentUserInfo.id,
                fromUserID: currentUserId,
                chatRoomId: selectedChatId
              };
              socketCheck.send(JSON.stringify({ 'message': message, 'user': sentUserInfo.id, 'chat_data': sentData }));
              let socketTimeout = setTimeout(function(){
                bus.$emit('newChatMessage', payload);
                clearTimeout(socketTimeout);
              },2500);
              messageInputDom.value = '';
              // console.log('message', message, 'user', sentUserInfo.id, 'chat_data', sentData)
              var elmnt = document.getElementById("chatbot_scroll");
              var y = elmnt.scrollHeight;
              setTimeout(() => {
                $('#chatbot_scroll').scrollTop(y)
              }, 100)
            }
          };
        }
      })
    },
    blockedUserFun(id, email) {
      this.blockedUserId = id
      this.blockedUserEmail= email
      this.checkDataTaskModal = true
    },
    confirmBlockedUser(){
      let data = {
        blocked_user : this.blockedUserId
      }
      this.listLoading = true
      this.$store.dispatch('createBlockUserFun', data )
      .then((res) => {
        this.$store.dispatch('normalChatListFun').then((res) => {
          this.normalChatListData = res.data.data
          // document.querySelector('#Chats_tabs').click()
          this.blockedUserId = ''
          this.blockedUserEmail= ''
          this.checkDataTaskModal = false
          this.listLoading = false
          toast.success(res.data.msg);
        })
      }).catch((error) => {
        toast.error(error.data.data.non_field_errors || error.data.msg)
        this.listLoading = false
      })
    },
    noConfirmBlockedUser(){
      this.blockedUserId = ''
      this.blockedUserEmail= ''
      this.checkDataTaskModal = false
    },
    cancelUploadFile() {
      this.uploadFile = null;
      this.filename = '';
      this.fileMessage = ''
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.uploadFile = event.target.files[0];
        this.filename = this.uploadFile.name
        if (typeof FileReader === 'function') {
          const reader = new FileReader();
          reader.onload = (event) => {
            this.imgSrc = event.target.result;
          };
          reader.readAsDataURL(this.uploadFile);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      }
    },
    fileMsgSubmit(){
      this.submitted = true
      let formData = new FormData();
      var sentUserInfo = JSON.parse(localStorage.getItem('adminNormalchatUserInfo'));
      let sentData = {
        'message': this.fileMessage,
        type: 'sent',
        email: sentUserInfo.email,
        name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
        file_is:true
      }
      let socketSentData = {
        'message': this.fileMessage,
        type: 'sent',
        email: sentUserInfo.email,
        name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
        is_file:true
      }
      let message =  this.uploadFile
      formData.append('chat_room_user', this.roomChatIdForFile);
      formData.append('message', this.fileMessage);
      formData.append('file', this.uploadFile);
      formData.append('filename', this.filename);
      formData.append('data',  JSON.stringify(sentData));
      this.listLoading = true
      this.$store.dispatch("uploadMsgFileInChatFun", formData).then((res) => {
        this.uploadedFileUrl = res.data.data.file
        // console.log( 'message', this.uploadedFileUrl, 'user', sentUserInfo.id, 'chat_data', socketSentData )
        this.socketCheck.send(JSON.stringify({ 'message': this.uploadedFileUrl, 'user': sentUserInfo.id, 'chat_data': socketSentData }))
        // document.querySelector('#chat-message-reply-input').value = this.uploadedFileUrl;
        // document.querySelector('#chat-message-reply-submit').click();
        toast.success(res.data.msg);
        this.$store.dispatch('getUserChatDetailsByIdFun', { id: this.roomChatIdForFile }).then((res) => {
          this.userChatContent = res.data.data
          this.uploadFile = null;
          this.filename = '';
          this.fileMessage = ''
          document.querySelector('#chat-message-reply-input').value = ''
          $('.sent_list').remove()
          $('.recieved_list').remove()
          this.listLoading = false
        })
      }).catch((err) =>{
        toast.error(err.data.msg);
        this.listLoading = false
      })
    },
    fileOpenNewTab(href){
      window.open(href, '_blank');
    }
  },
  watch: {
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters.data
    },
  },
  created() {
    // $('.chat_user_listed').first().addClass('active');
    // document.querySelector('.chat_user_listed.active').click()
  },
  beforeCreate: function () {
    $('body').addClass('normal_user_chatbot')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('normal_user_chatbot')
    this.checkSocketId = ''
    if(this.socketCheck){
      this.socketCheck.close();
    }
    next();
  },
}
